<script setup lang="ts">
    const model = defineModel<boolean>();
</script>

<template>
    <v-checkbox
        v-model="model"
        :indeterminate="model === undefined"
        color="primary"
        hide-details
    />
</template>
